/**
 * File that can be loaded in each page as a mixin, handles data table js code
 */
 export const dataTableMixin = {
    data() {
        return {
            getDataError: false,
            objects: []
        }
    },
    methods: {
        async getData() {
            try {
              this.dataTableProps.loading = true;
              this.objects = await this.getObjects();
              this.setSearchbarProps();
              this.$set(this.dataTableProps, 'filteredObjects', this.filteredObjects);
            } catch (err) {
              this.dataTableProps.getDataError = true;
              this.objects = [];
            } finally {
              this.dataTableProps.loading = false;
            }
        },
    },
    //These watch values for changes
    watch: {
        filteredObjects(){
            this.$set(this.dataTableProps, 'filteredObjects', this.filteredObjects);
        }
    }
    
}